(function () {
    'use strict';
    /**
     * Main part of the application, where the underlying angular modules are loaded.
     */
    angular.module('ib-check-in-app', [
        'ib-check-in-app-constants-module',
        'web-checkin-templates',
        'ngRoute',
        'utf8-base64',
        'pascalprecht.translate',
        'ngCookies',
        'ui.bootstrap',
        'ngAnimate',
        'ui.select',
        'ngAria',
        'slickCarousel',
        'LocalStorageModule',
        'credit-cards',
        'ng.deviceDetector',
        'duScroll',
        'ngMessages',
        'ngScrollbars',
        'rzModule',
        // 'timer',
        'rx',
        'oc.lazyLoad',
        'ib-commons-http-new-service-module',
        'ib-interceptors-module',
        'ib-commons-login-module',
        'ib-ui-login-reusable-iframe-component',
        'ib-commons-utils-module',
        'ib-commons-http-service-module',
        'ib-commons-modal-service-module',
        'ib-commons-proxies-module',
        'ib-commons-keep-alive-module',
        'ib-commons-directives-module',
        'ib-datalayer-module',
        'ib-datalayer-cki-module',
        'ib-check-in-search',
        'ib-web-menus-module',
        'ib-checkin-flights-passengers-module',
        'ib-checkin-ib-plus',
        'ib-shared-services-module',
        'ib-apis-form-module',
        'ib-check-in-apis-module',
        // 'ib-boarding-cards-module',
        'ib-flight-now-module',
        'ib-filter-module',
        'angular-bind-html-compile',
        // 'ib-fly-now-confirmation-module',
        // 'ib-checkin-flights-des-invoice-module',
        // 'ib-pmt-module',
        // 'ib-pmt-order-confirmation-module',
        // 'ib-check-in-confirmation-module',
        // 'ib-check-in-upgrade-module',
        // 'ib-checkin-biometric-boarding-module',
        'ib-commons-filters-module',
        'ib-components-module',
        'ib-commons-constants-module',
        'ib-commons-avios-constants',
        'ngSanitize',
        'ib-commons-ui-components-module',
        'ib-header-main-page-component-module',
        'ib-checkin-services-module',
        // 'ib-checkin-ancillaries-module',
        'ib-loading-redirection-module',
        'ib-check-in-app-constants-module',
        ]);

    angular.module('ib-check-in-app').run(initCheckInApp);

    initCheckInApp.$inject = ['CheckinRouterConstants', 'CommonsLanguageAndMarketService', '$translate', 'CheckinAppConstants', '$rootScope', 'ComponentUtils', '$window', 'AddOnService', 'DatalayerUtilsService', 'CkiDatalayerUtilsService', 'UtilsService', 'CommonsAncillariesService', 'IbCLinksService', 'ModalService', 'MonetateUtilsService', 'CommonsUtilService', 'localStorageService', 'CommonsGetWcsPhonesService', 'CommonsKeepAliveUtilsService', 'TranslateFactoryService','CommonsSessionStorageService'];
    function initCheckInApp (CheckinRouterConstants, CommonsLanguageAndMarketService, $translate, CheckinAppConstants, $rootScope, ComponentUtils, $window, AddOnService, DatalayerUtilsService, CkiDatalayerUtilsService, UtilsService, CommonsAncillariesService, IbCLinksService, ModalService, MonetateUtilsService, CommonsUtilService, localStorageService, CommonsGetWcsPhonesService, CommonsKeepAliveUtilsService, TranslateFactoryService,CommonsSessionStorageService) {
        //Initilize language and market
        const marketLang = CommonsLanguageAndMarketService.init();
        marketLang.market = UtilsService.filterMarket(marketLang.market);
        //Set translation language to use
        $translate.use(marketLang.language);
        TranslateFactoryService.setLanguage(marketLang.language);
        CommonsSessionStorageService.setPrefix('ib-check-in-app');
        //Initialize const
        $rootScope.appMarket = marketLang.market;
        $rootScope.appLang = marketLang.language;
        CheckinAppConstants.market = marketLang.market;
        CheckinAppConstants.lang = marketLang.language;
        $rootScope.flowName = CheckinAppConstants.flowName;
        $rootScope.otpServicesURI = CheckinAppConstants.otpServicesURI;
        $rootScope.METAS = CheckinAppConstants.METAS[marketLang.language];
        $rootScope.CHECKIN_FIELDS_LENGTH = CheckinAppConstants.CHECKIN_FIELDS_LENGTH;
        $rootScope.CHECKIN_PATTERNS = CheckinAppConstants.CHECKIN_PATTERNS;
        $rootScope.GOOGLE_ADS_URIS = CheckinAppConstants.GOOGLE_ADS_URIS;
        $rootScope.BANNER_IDS = CheckinAppConstants.BANNER_IDS;
        $rootScope.routes = {
            icons: CheckinAppConstants.iconsRoute,
            images: CheckinAppConstants.imagesRoute,
            templates: CheckinRouterConstants.templatesRoute
        };
        IbCLinksService.getLinks(true, 'CKI').then(() => {
            $rootScope.loadLinks = true;
        });
        $rootScope.loadLinks = false;
        $rootScope.serviceAncillarie = CommonsAncillariesService;
        $rootScope.serviceModal = ModalService;
        $rootScope.showMainHeader = false;
        $rootScope.showHeaders = true;
        $rootScope.hideAdvancedSearch = true;
        $rootScope.generateDatalayerDOM = CkiDatalayerUtilsService.generateDatalayerDOM;
        $rootScope.serviceURI = CheckinAppConstants.servicesURI;
        $rootScope.paymentBackgroundImageUrl = UtilsService.getPaymentsBackGroundURL();
        $rootScope.backGroundImage = UtilsService.getPaymentsBackGroundURL();
        localStorageService.set('flowApp', 'CKI');
        DatalayerUtilsService.initializeDatalayer(marketLang.language, marketLang.market, UtilsService.getDeviceType());
        CkiDatalayerUtilsService.initializeDatalayer(marketLang.language, marketLang.market, UtilsService.getDeviceType());
        MonetateUtilsService.initializeMonetate(marketLang.language, marketLang.market, UtilsService.getDeviceType());
        $rootScope.isMobile = CommonsUtilService.isMobile();
        angular.element($window).bind('resize', () => {
            if (angular.element('.ibe-box-form').length) {
                ComponentUtils.resizeHeightListElements('.ibe-box-form');
            }
        });
        $rootScope.phonesList = {};
        CommonsGetWcsPhonesService.getPhoneByCode(CheckinAppConstants.WCS.PHONE_TYPES.SALES).then(() => {
            $rootScope.phonesList = localStorageService.get('phonesList') || {};
        });
        const preconditionEvent = $rootScope.$on('$routeChangeStart', (event) => {
            const paramPaRes = UtilsService.getParameterByName('PaRes');
            const paramMD = UtilsService.getParameterByName('MD');
            if (paramMD && paramPaRes) {
                event.preventDefault();
                localStorageService.set('componentInfoAdyen', {md: paramMD, paRes: paramPaRes});
                $window.location = $window.location.pathname + $window.location.search.split(/[?&]MD(=([^&#]*)|&|#|$)[?&]PaRes(=([^&#]*)|&|#|$)/)[0];
            }
        });
        /* Events initials */
        const warnUserOnBackPressedEvent = $rootScope.$on('warnUserOnBackPressed', (event, history, window, location, angular, closeModal) => {
            UtilsService.warnUserOnBackPressed(history, window, location, angular, closeModal);
        });

        const backToMainEvent = $rootScope.$on('backToMainRoot', (event, goToHome, closeSession) => {
            UtilsService.backToMain(event, goToHome, closeSession);
        });

        CommonsKeepAliveUtilsService.initKeepAlive();
        AddOnService.initAddOn();
        /////////////////////////////////////////
    }
})();
